import type { ErrorResponse } from '../../shared/types'
import type { CustomerEntity, PaymentEntity, PaymentMethodEntity, StripePaymentMethodEntity } from './entities'
import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { Identifier } from '../../shared/types'
import { ChargeCustomer, PaymentRequiredResponseSchema } from './entities'

const c = initContract()

const options = {
  pathPrefix: '/customers',
}

export const paymentCustomersContract = c.router({
  getCustomer: {
    method: 'GET',
    path: '/:userId',
    pathParams: z.object({
      userId: Identifier,
    }),
    responses: {
      200: c.type<CustomerEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  chargeCustomer: {
    method: 'POST',
    path: '/:userId/payments',
    pathParams: z.object({
      userId: Identifier,
    }),
    body: ChargeCustomer,
    responses: {
      201: c.type<PaymentEntity>(),
      402: PaymentRequiredResponseSchema,
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  getPaymentMethods: {
    method: 'GET',
    path: '/:userId/payments-methods',
    pathParams: z.object({
      userId: Identifier,
    }),
    responses: {
      200: c.type<StripePaymentMethodEntity[]>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  setDefaultPaymentMethod: {
    method: 'POST',
    path: '/:userId/payment-methods/:paymentMethodId/set-default',
    pathParams: z.object({
      userId: Identifier,
      paymentMethodId: z.string(),
    }),
    body: null,
    responses: {
      200: c.type<CustomerEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  createPaymentMethod: {
    method: 'POST',
    path: '/create-payment-method',
    body: z.object({
      paymentMethodId: z.string(),
      userId: Identifier,
      provider: z.string(),
    }),
    responses: {
      200: c.type<PaymentMethodEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  deletePaymentMethod: {
    method: 'DELETE',
    path: '/:userId/payment-method/:paymentMethodId',
    pathParams: z.object({
      userId: Identifier,
      paymentMethodId: z.string(),
    }),
    responses: {
      200: c.type<StripePaymentMethodEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
}, options)
